export const ACTIVITY_MULTIPLIERS = {
  sedentario: { label: "Sedentario", value: 1.2, desc: "Poco o nessun esercizio" },
  leggero: { label: "Leggero", value: 1.375, desc: "1-3 giorni/settimana" },
  moderato: { label: "Moderato", value: 1.55, desc: "3-5 giorni/settimana" },
  attivo: { label: "Attivo", value: 1.725, desc: "6-7 giorni/settimana" },
  molto_attivo: { label: "Molto Attivo", value: 1.9, desc: "Allenamento intenso quotidiano" },
};

export function calculateTDEE(weight, height, age, gender, activityLevel) {
  if (!weight || !height || !age || !gender || !activityLevel) return null;
  // Mifflin-St Jeor
  let bmr;
  if (gender === "M") {
    bmr = 10 * weight + 6.25 * height - 5 * age + 5;
  } else {
    bmr = 10 * weight + 6.25 * height - 5 * age - 161;
  }
  const multiplier = ACTIVITY_MULTIPLIERS[activityLevel]?.value || 1.2;
  return { bmr: Math.round(bmr), tdee: Math.round(bmr * multiplier) };
}

export function getAgeFromDob(dob) {
  if (!dob) return null;
  const birth = new Date(dob);
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const m = now.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
  return age > 0 ? age : null;
}
